import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "xwzx-wrapper"
};
const _hoisted_2 = {
  class: "xwzx-page"
};
const _hoisted_3 = {
  class: "search-section"
};
const _hoisted_4 = {
  key: 0,
  class: "loading-wrapper"
};
const _hoisted_5 = {
  key: 1,
  class: "news-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 0,
  class: "news-cover"
};
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
  class: "news-info"
};
const _hoisted_10 = {
  class: "news-title"
};
const _hoisted_11 = {
  key: 0,
  class: "news-subtitle"
};
const _hoisted_12 = {
  key: 1,
  class: "news-summary"
};
const _hoisted_13 = {
  class: "news-meta"
};
const _hoisted_14 = {
  key: 0,
  class: "news-author"
};
const _hoisted_15 = {
  class: "news-time"
};
const _hoisted_16 = {
  key: 2,
  class: "empty-wrapper"
};
const _hoisted_17 = {
  key: 3,
  class: "pagination-wrapper"
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { searchArticles } from '@/api/news';
export default /*@__PURE__*/_defineComponent({
  __name: 'Xwzx',
  setup(__props) {
    const router = useRouter();
    const newsList = ref([]);
    const loading = ref(true);
    const pageNum = ref(1);
    const pageSize = ref(10);
    const total = ref(0);
    const searchKey = ref('');
    const fetchNewsList = async () => {
      try {
        loading.value = true;
        const res = await searchArticles({
          pageNum: pageNum.value,
          pageSize: pageSize.value,
          searchKey: searchKey.value
        });
        if (res.data && res.data.list) {
          newsList.value = res.data.list;
          total.value = res.data.total || 0;
        }
      } catch (error) {
        console.error('获取新闻列表失败:', error);
      } finally {
        loading.value = false;
      }
    };
    const handleSearch = () => {
      pageNum.value = 1;
      fetchNewsList();
    };
    const handlePageChange = () => {
      fetchNewsList();
    };
    const goToDetail = id => {
      router.push(`/xwxq/${id}`);
    };
    const formatDate = dateStr => {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    onMounted(() => {
      fetchNewsList();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner"
      }, [_createElementVNode("div", {
        class: "banner-title"
      }, "新闻中心")])], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
        modelValue: searchKey.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKey.value = $event),
        placeholder: "请输入搜索关键词",
        class: "search-input",
        onKeyup: _withKeys(handleSearch, ["enter"])
      }, {
        append: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: handleSearch
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("搜索", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[4] || (_cache[4] = [_createElementVNode("div", {
        class: "loading-text"
      }, "加载中...", -1)]))])) : newsList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, news => {
        return _openBlock(), _createElementBlock("div", {
          key: news.id,
          class: "news-item",
          onClick: $event => goToDetail(news.id)
        }, [news.coverImage ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("img", {
          src: news.coverImage,
          alt: news.title
        }, null, 8, _hoisted_8)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(news.title), 1), news.subtitle ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(news.subtitle), 1)) : _createCommentVNode("", true), news.summary ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(news.summary), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [news.author ? (_openBlock(), _createElementBlock("span", _hoisted_14, "作者：" + _toDisplayString(news.author), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_15, _toDisplayString(formatDate(news.publishTime)), 1)])])], 8, _hoisted_6);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[5] || (_cache[5] = [_createElementVNode("div", {
        class: "empty-text"
      }, "暂无新闻数据", -1)]))])), total.value > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_el_pagination, {
        "current-page": pageNum.value,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => pageNum.value = $event),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => pageSize.value = $event),
        total: total.value,
        layout: "prev, pager, next",
        onCurrentChange: handlePageChange
      }, null, 8, ["current-page", "page-size", "total"])])) : _createCommentVNode("", true)]), _createVNode(_component_Footer)]);
    };
  }
});